import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useEncodedParams } from '../../hooks/useParams'

export interface ForwardProps {
  to: string
}

/**
 * React Router utility function that forwards
 * to another route, translates url params, and copies search params.
 */
export const Forward = ({ to }: ForwardProps) => {
  const params = useEncodedParams()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  // Translate old url params to new path.
  const pathName = Object.keys(params).reduce(
    (prev, key) => prev.replace(`:${key}`, params[key]!),
    to,
  )

  const search = searchParams.toString()
  const target = search ? `${pathName}?${search}` : pathName

  useEffect(() => {
    navigate(target, { replace: true })
  }, [navigate, target])

  return null
}
